import { render, staticRenderFns } from "./DiscardPopup.vue?vue&type=template&id=56e38734&scoped=true"
import script from "./DiscardPopup.vue?vue&type=script&lang=ts"
export * from "./DiscardPopup.vue?vue&type=script&lang=ts"
import style0 from "./DiscardPopup.vue?vue&type=style&index=0&id=56e38734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e38734",
  null
  
)

export default component.exports